<template>
  <div class="cert-app">
    <main v-if="isAuthLayout" class="cert-auth-main">
      <RouterView v-slot="{ Component }">
        <Transition mode="out-in">
          <component :is="Component" />
        </Transition>
      </RouterView>
    </main>

    <AppShell v-else />
  </div>
</template>

<script setup>
import { computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import AppShell from "@/layouts/AppShell.vue";

const route = useRoute();

const isAuthLayout = computed(() => route.meta?.layout === "auth");

onMounted(() => {
  checkAppVersion();
});

async function checkAppVersion() {
  try {
    const response = await fetch(`/version.json?t=${Date.now()}`, {
      cache: "no-store",
    });

    const data = await response.json();
    const currentVersion = localStorage.getItem("app_version");

    if (!currentVersion) {
      localStorage.setItem("app_version", data.version);
      return;
    }

    if (currentVersion !== data.version) {
      localStorage.setItem("app_version", data.version);

      if ("caches" in window) {
        const cacheKeys = await caches.keys();
        await Promise.all(cacheKeys.map((key) => caches.delete(key)));
      }

      window.location.reload();
    }
  } catch (error) {
    console.error("Erro ao verificar versão do app:", error);
  }
}
</script>

<style lang="scss">
#app {
  min-height: 100vh;
  font-family: "Xolonium", Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.cert-app {
  min-height: 100vh;
}

.cert-auth-main {
  min-height: 100vh;
}

::-webkit-scrollbar {
  width: 2px;
  height: 1px;
}

::-webkit-scrollbar-thumb {
  background-color: #ff7a00;
  border-radius: 2px;
}

::-webkit-scrollbar-track {
  background-color: #1b1e25;
  border-radius: 2px;
}
</style>
